import * as qiniu from 'qiniu-js'
import {createRequest} from '../utils/utils'

/**
 * 七牛云上传
 * @param {*} file  二进制文件
 * @param {*} token  用户token
 * @param {*} format  文件格式 （后缀名）
 * @param {*} process  上传进度
 * @param {*} callback  上传结果(err,dat)
 */
export function uploadQiniu(file,format,process,callback){
    console.log('file',file)
    return new Promise((resolve,reject)=>{
        createRequest('GET','applet/publics/qiniu/token',{format:format},(res)=>{
            console.log(res)
            if(res.code==200){
                const observable = qiniu.upload(file, res.data.key, res.data.token) 
                const subscription = observable.subscribe(next=>{
                    process && process({
                        size:next.total.size,
                        loaded:next.total.loaded,
                        percent:next.total.percent
                    })
                }, error=>{
                    callback && callback('上传失败')
                }, complete=>{
                    callback && callback(null,res.data)
                })
                return resolve(subscription)
            }
            else{
                callback && callback('上传失败')
                reject('上传失败')
            }
        })    
    })
    
}
export function uploadQiniuSetKey(file,fileName,process,callback){
    console.log('file',file)
    return new Promise((resolve,reject)=>{
        if(fileName.length>20){
            callback && callback('文件名不能超20字符')
            return reject('文件名不能超20字符')
        }
        createRequest('GET','applet/publics/qiniu/token',{file_name:fileName},(res)=>{
            console.log(res)
            if(res.code==200){
                const observable = qiniu.upload(file, res.data.key, res.data.token) 
                const subscription = observable.subscribe(next=>{
                    process && process({
                        size:next.total.size,
                        loaded:next.total.loaded,
                        percent:next.total.percent
                    })
                }, error=>{
                    callback && callback('请重试')
                }, complete=>{
                    callback && callback(null,res.data)
                })
                return resolve(subscription)
            }
            else{
                callback && callback('请重试')
                reject('请重试')
            }
        })    
    })
    
}


// WEBPACK FOOTER //
// ./src/qiniu/index.js